module.exports = __webpack_public_path__ + "static/media/game-icon-hear.bd28381d.png";